(function () {
    $ (function () {
        $ ('.js-carousel-horizontal-rows2').each ((i, el) => {
            initSlider ($ (el));
        });
        
        $ (document).on ('slick:init', '.js-carousel-horizontal-rows2', (e, $el) => {
            initSlider ($el);
        });
        
        function initSlider ($el) {
            const $carousel = $el;
            const $wrap = $carousel.parents ('[data-role="wrap"]');
            const $prev = $wrap.find ('[data-role="prev"]');
            const $next = $wrap.find ('[data-role="next"]');
            
            // Init
            let settings = {
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                dotsClass: "b-carousel-footer",
                touchThreshold: 10,
                infinite: false,
                
                responsive: [
                    {
                        breakpoint: globObj.breakpoints.md,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: globObj.breakpoints.lg,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            arrows: true,
                            dots: false
                        }
                    }
                ]
            };
            
            if ($prev.length > 0) {
                settings.prevArrow = $prev;
            }
            
            if ($next.length > 0) {
                settings.nextArrow = $next;
            }
            
            $carousel.slick (settings);
        }
    })
} ());
